import { cellRenderParseData } from '../../../utils/functions';

const columnDataGrid = [
  {
    dataField: 'accountingDate',
    caption: 'Дата СК',
    cellRender: cellRenderParseData,
    dataType: 'date'
  },
  {
    dataField: 'actualPieceId',
    caption: 'Номер УЕ',
    dataType: 'string'
  },
  {
    dataField: 'batchId',
    caption: 'Партия SAP',
    dataType: 'string'
  },
  {
    dataField: 'cgId',
    caption: 'Номер партии',
    dataType: 'string'
  },
  {
    dataField: 'productGroupDescription',
    caption: 'Продукт',
    dataType: 'string'
  },
  {
    dataField: 'checkbox',
    caption: 'Чекбокс',
    dataType: 'string',
    notVisible: true
  },
  {
    dataField: 'incomingDate',
    caption: 'Дата поступления',
    cellRender: cellRenderParseData,
    dataType: 'string'
  },
  {
    dataField: 'percentWasteMaterial',
    caption: '% отходов',
    dataType: 'number'
  },
  {
    dataField: 'pieceNumId',
    caption: 'Ключ УЕ ПФ',
    dataType: 'integer',
    notVisible: true
  },
  {
    dataField: 'psStatusName',
    caption: 'Статус',
    dataType: 'string'
  },
  {
    dataField: 'psStatusNumId',
    caption: 'Номер статуса',
    dataType: 'number',
    notVisible: true
  },
  {
    dataField: 'qcId',
    caption: '№СК ПФ',
    dataType: 'string'
  },
  {
    dataField: 'quantity',
    caption: 'Учетное кол-во',
    dataType: 'number'
  },
  {
    dataField: 'unitShort',
    caption: 'ЕИ',
    dataType: 'string'
  },
  {
    dataField: 'quantityCurrent',
    caption: 'Кол-во списания',
    dataType: 'number'
  },
  {
    dataField: 'quantityRemain',
    caption: 'Кол-во, ост.',
    dataType: 'number'
  },
  {
    dataField: 'zdvlLineId',
    caption: 'Позиция заказа',
    dataType: 'string'
  },
  {
    dataField: 'zdvlOrderNumId',
    caption: 'Заказ ZDVL',
    dataType: 'string'
  },
  {
    dataField: 'taskNumber',
    caption: 'Номер задания',
    dataType: 'string'
  },
  {
    dataField: 'pieceId',
    caption: 'Маркировка',
    dataType: 'string'
  },
  {
    dataField: 'plantDescr',
    caption: 'Склад',
    dataType: 'string'
  }
];

export default columnDataGrid;
